import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'
import { ButtonPrimary } from '~/components/Buttons'
import { ArticleProductAPIStat } from '~/redux/apis/user-stats-api'
import useArticleProductCardStats from '~/statistics/hooks/useEncyclopediaCardsStats'
import { AppLanguage } from '~/types/locale'

import ROUTES from '~/shared/constants/routes.const'
import { useHasPremiumAccess } from '~/redux/utils/subscription'

import ActivitySetsSummary from '../Bootcamp/ActivitySetsSummary'
import ActivitySetProgress from '../CircularProgress'

export default function Details({ product }: { product: ArticleProductAPIStat }): React.ReactElement {
  const { t } = useTranslation('statistics')
  const hasFullAccess = useHasPremiumAccess()
  const { locale, asPath } = useRouter()
  const isFamilyView = asPath.includes(ROUTES.FAMILY_ADMIN_PANEL)

  const {
    activitySetsProgress,
    activitiesSummary: { totalSetsCount, setsCompletedCount },
    totalAnswered,
    path,
    articleRead,
  } = useArticleProductCardStats(product)

  const onClickContinueBtn = (): void => {
    statisticsAnalytics.logButtonClick('continue')
  }

  return (
    <div>
      <div className="relative">
        <div className="mt-2">
          <div className="flex items-center space-x-2 mt-3 mb-5">
            <ActivitySetProgress percentage={articleRead ? 100 : 0} />
            <p>{t('articleRead')}</p>
          </div>
          {totalSetsCount && (
            <ActivitySetsSummary
              setsCompletedCount={setsCompletedCount}
              setsProgress={activitySetsProgress}
              totalAnswered={totalAnswered}
              totalSetsCount={totalSetsCount}
            />
          )}
        </div>

        {path && !isFamilyView && hasFullAccess && (
          <ButtonPrimary
            className="ml-auto mt-4 px-2"
            href={path}
            locale={locale as AppLanguage}
            noPadding
            onClick={onClickContinueBtn}
            size="medium"
          >
            {t('continue')}
          </ButtonPrimary>
        )}
      </div>
    </div>
  )
}
